module.exports = __webpack_public_path__ + "src/assets/img/YDL-Logo.2ce01416.svg";